import { render } from "./UploadPhoto.vue?vue&type=template&id=2f35ce47&scoped=true"
import script from "./UploadPhoto.vue?vue&type=script&lang=js"
export * from "./UploadPhoto.vue?vue&type=script&lang=js"

import "./UploadPhoto.vue?vue&type=style&index=0&id=2f35ce47&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f35ce47"],['__file',"resources/js/modules/product-submission/components/UploadPhoto.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f35ce47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f35ce47', __exports__)) {
    api.reload('2f35ce47', __exports__)
  }
  
  module.hot.accept("./UploadPhoto.vue?vue&type=template&id=2f35ce47&scoped=true", () => {
    api.rerender('2f35ce47', render)
  })

}


export default __exports__